import React from 'react';
import { Trash2 } from 'lucide-react';
import { deleteCupon, Cupon } from '../../services/couponService';

interface DeleteModalProps {
    isOpen: boolean;
    onClose: () => void;
    cupon: Cupon | null;
    onDeleted: (id: number) => void;
}

const DeleteModalCupon: React.FC<DeleteModalProps> = ({
    isOpen,
    onClose,
    cupon,
    onDeleted,
}) => {
    const [isDeleting, setIsDeleting] = React.useState(false);

    if (!isOpen || cupon === null) return null;

    const handleDelete = async () => {
        setIsDeleting(true);
        try {
            await deleteCupon(cupon.id);
            onDeleted(cupon.id);
            onClose();
        } catch (error) {
            console.error('Error eliminando cupón:', error);
        } finally {
            setIsDeleting(false);
        }
    };

    const getTextoEliminacion = () => {
        if (cupon.plan_aplicable) {
            return `del servicio ${cupon.plan_aplicable.servicio_nombre} y plan ${cupon.plan_aplicable.plan_nombre}`;
        }
        return 'de todos los servicios y planes';
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white p-8 rounded-2xl w-full max-w-md border border-gray-100 shadow-2xl">
                <div className="flex justify-between items-start mb-6">
                    <h3 className="text-[20px] font-bold text-gray-900">Confirmar eliminación</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                        aria-label="Cerrar modal"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <p className="mb-8 text-gray-600">
                    ¿Estás seguro que deseas eliminar el cupón{' '}
                    <strong className="text-red-600">"{cupon.codigo}"</strong> {getTextoEliminacion()}?
                </p>

                <div className="flex justify-end gap-3 mt-8">
                    <button
                        onClick={onClose}
                        disabled={isDeleting}
                        className="px-5 py-2.5 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200 font-medium text-[14px]"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleDelete}
                        disabled={isDeleting}
                        className="px-5 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200 font-medium shadow-sm flex items-center text-[14px]"
                    >
                        <Trash2 className="w-4 h-4 mr-2" />
                        {isDeleting ? 'Eliminando...' : 'Eliminar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteModalCupon;
